import React, { useEffect, useState } from 'react';
import { Formik, Field } from 'formik';
import styled from 'styled-components';
import Moment from 'moment';
import {
  RenderTextField,
  RenderToggleSwitch,
  required,
  isPriceValidation,
} from '../../../../../../components/FormElements/FormikElements';
import { Button, ButtonRow } from 'merchant-portal-components';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Icon } from 'merchant-portal-components';
import MenuItem from '@material-ui/core/MenuItem';
import {
  Collapse,
  Menu,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import ConfirmCancelModal from '../../../../../MenuManagement/Products/ProductWizard/components/ConfirmCancelModal';
import ChevronUpIcon from '../../../../../../components/Icon/ChevronUpIcon';
import ChevronDownIcon from '../../../../../../components/Icon/ChevronDownIcon';
import { useMemo } from 'react';
const Card = styled.div`
  background-color: ${(props) => (props.disabled ? '#ebebeb' : 'white')};
  color: ${(props) => (props.disabled ? '#191818' : 'inherit')};
  border-radius: 20px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.14);
  margin-bottom: 24px;
  padding-right: 20px;
`;
export const TitleAndCollapseButton = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  padding: 20px 30px 20px 40px;
  margin: 10px;
`;
const FormWrapper = styled.div`
  padding: 20px 48px 20px 48px;
  display: grid;
  grid-gap: 20px;
`;

const FieldWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 20px;
  align-items: center;
`;

const Headline = styled.p`
  font-size: 17px;
  font-weight: 600;
`;

const OrderSettingsWrapper = styled.div`
  display: grid;
  grid-template-columns: 150px 1fr 100px;
  grid-gap: 20px;
  align-items: center;
`;
const AddOverrideWrapper = styled.div`
  margin-bottom: 10px;
`;

const AddOverride = styled.div`
  display: grid;
  grid-template-columns: 15px 190px auto;
  grid-gap: 5px;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  max-width: 205px;
`;
const OrderTypeWrapper = styled.div`
  display: grid;
  grid-template-columns: 30px 200px 300px;
  grid-gap: 20px;
  align-items: center;
  margin-bottom: 15px;
`;
const Title = styled.div`
  font-weight: 600;
  font-size: 21px;
  opacity: ${(props) => (props.disabled ? '0.5' : 'none')};
  /* margin: 40px 0 0 48px; */
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  align-items: center;
`;

const BusinessInformationForm = ({
  initialValues,
  currencyList,
  handleSubmit,
  externalIdIsVisible,
  is_delivery_enabled,
  deactivateSection,
  isBusinessAdminRole,
  orderTypeTransactionLimit,
  orderTypesList,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [orderTypeOverrides, setOrderTypeOverrides] = useState([]);
  const [confirmCancelModalIsVisible, setConfirmCancelModalIsVisible] =
    useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [localOrderTypeTransactionLimit, setLocalOrderTypeTransactionLimit] =
    useState(orderTypeTransactionLimit);

  const availableOrderTypes = useMemo(() => {
    const currentOrderTypes = JSON.parse(JSON.stringify([...orderTypesList]));
    const availableTypes = currentOrderTypes.map((item) =>
      item.type === 'Drop off' ? 'drop_off' : item.type.toLowerCase()
    );
    console.log('availableTypes', availableTypes);
    return availableTypes;
  }, [orderTypesList]);

  const orderTypesInTooltip = useMemo(() => {
    let orderTypeNames = orderTypesList?.map((item) => item.type);

    let tooltipTypes = '';
    if (orderTypeNames.length === 1) {
      tooltipTypes = orderTypeNames[0];
    } else if (orderTypeNames.length > 1) {
      tooltipTypes = orderTypeNames.join(' or ');
    }

    return tooltipTypes;
  }, [orderTypesList]);

  const handleUpdateOrderTypeMaximumLimit = (orderType, limit) => {
    // if (isNaN(limit) || limit === '') {
    //   console.log('Invalid input: limit is not a number');
    //   return;
    // }
    const newLimit = [...localOrderTypeTransactionLimit];
    const index = newLimit.findIndex((item) => item.order_type === orderType);
    if (index !== -1) {
      newLimit[index].limit = parseFloat(limit);
    } else {
      newLimit.push({ order_type: orderType, limit: parseFloat(limit) });
    }
    setLocalOrderTypeTransactionLimit(newLimit);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddOverride = (orderType) => {
    if (!orderTypeOverrides.includes(orderType)) {
      setOrderTypeOverrides((prevState) => [...prevState, orderType]);
    }
    setAnchorEl(null);
  };
  const handleRemoveOverride = (orderType) => {
    setOrderTypeOverrides((prevState) =>
      prevState.filter((item) => item !== orderType)
    );
    const index = localOrderTypeTransactionLimit.findIndex(
      (item) => item.order_type === orderType
    );
    if (index !== -1) {
      const updatedLimit = localOrderTypeTransactionLimit.filter(
        (item) => item.order_type !== orderType
      );
      setLocalOrderTypeTransactionLimit(updatedLimit);
    }
  };

  useEffect(() => {
    if (orderTypeTransactionLimit?.length > 0) {
      setOrderTypeOverrides(
        orderTypeTransactionLimit.map((item) => item.order_type)
      );
    }
  }, [orderTypeTransactionLimit?.length]);

  return (
    <Card disabled={deactivateSection}>
      <TitleAndCollapseButton>
        <Title disabled={deactivateSection}>Business Information</Title>
        {!isExpanded ? (
          <ChevronDownIcon
            disabled={!deactivateSection ? false : 'true'}
            style={{
              opacity: !deactivateSection ? 'none' : '0.5',
            }}
            onClick={() => {
              setIsExpanded(true);
            }}
          />
        ) : (
          <ChevronUpIcon
            // disabled={dirty}
            onClick={() => {
              setIsExpanded(false);
            }}
          />
        )}
      </TitleAndCollapseButton>
      <Collapse in={isExpanded}>
        <Formik initialValues={initialValues} enableReinitialize={true}>
          {({ values, isValid, setFieldValue, dirty, handleReset, errors }) => (
            <FormWrapper>
              <FieldWrapper>
                <Field
                  disabled={deactivateSection}
                  name='businessInformation.business_name'
                  component={RenderTextField}
                  label='Internal Location Name *'
                  validate={required}
                />
              </FieldWrapper>
              {externalIdIsVisible && (
                <GridWrapper>
                  <Field
                    disabled={deactivateSection}
                    name='businessInformation.external_id'
                    component={RenderTextField}
                    label='External ID *'
                    validate={required}
                  />
                </GridWrapper>
              )}
              <Headline>Order Settings</Headline>
              <OrderSettingsWrapper>
                <Field
                  disabled={deactivateSection}
                  component={RenderTextField}
                  style={{ position: 'relative', top: '-4px' }}
                  type='text'
                  name='businessInformation.currency'
                  label='Currency *'
                  select
                  variant='outlined'
                  margin='normal'
                  validate={required}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  {currencyList.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Field>
                <Field
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>
                        <Icon className='fal fa-dollar-sign' />
                      </InputAdornment>
                    ),
                  }}
                  disabled={deactivateSection}
                  name='businessInformation.transaction_amount_limit'
                  component={RenderTextField}
                  label='Maximum Order Amount *'
                  validate={isPriceValidation}
                />
              </OrderSettingsWrapper>
              {availableOrderTypes.length > 1 && (
                <AddOverrideWrapper>
                  <AddOverride onClick={handleClick}>
                    <Icon className='fal fa-plus' />
                    <span style={{ fontSize: 14, cursor: 'pointer' }}>
                      Add Order Type Override
                    </span>
                    <Tooltip
                      title={`Add a transaction limit override for a specific order type (${orderTypesInTooltip}). Note: The override limit must be less than or equal to the maximum order amount.`}
                      placement='top'
                    >
                      <Icon className='fal fa-info-circle' />
                    </Tooltip>
                  </AddOverride>
                  <Menu
                    id='simple-menu'
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    F
                    onClose={handleClose}
                    style={{ marginTop: 35, marginLeft: 225 }}
                  >
                    {availableOrderTypes.includes('pickup') && (
                      <MenuItem
                        onClick={() => handleAddOverride('pickup')}
                        style={{ width: 150 }}
                      >
                        <Icon
                          className='fas fa-car-side'
                          style={{ width: 30 }}
                        />
                        Pickup
                      </MenuItem>
                    )}
                    {availableOrderTypes.includes('drop_off') && (
                      <MenuItem
                        onClick={() => handleAddOverride('drop_off')}
                        style={{ width: 150 }}
                      >
                        <Icon
                          className='fas fa-shopping-bag'
                          style={{ width: 30 }}
                        />
                        Drop Off
                      </MenuItem>
                    )}

                    {availableOrderTypes.includes('delivery') && (
                      <MenuItem
                        onClick={() => handleAddOverride('delivery')}
                        style={{ width: 150 }}
                      >
                        <Icon
                          className='fas fa-walking'
                          style={{ width: 30 }}
                        />
                        Delivery
                      </MenuItem>
                    )}
                  </Menu>
                  {orderTypeOverrides.includes('pickup') && (
                    <OrderTypeWrapper>
                      <Icon
                        className='fal fa-trash-alt'
                        onClick={() => handleRemoveOverride('pickup')}
                      />
                      <Typography
                        variant='h6'
                        style={{ fontSize: 14, cursor: 'pointer' }}
                        onClick={() => handleRemoveOverride('pickup')}
                      >
                        Remove Pickup Override
                      </Typography>
                      <TextField
                        label='Pick-up Maximum Order Amount'
                        value={
                          localOrderTypeTransactionLimit?.find(
                            (item) => item.order_type === 'pickup'
                          )?.limit || null
                        }
                        placeholder='Amount'
                        variant='outlined'
                        size='small'
                        type='number'
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>
                              <Icon className='fal fa-dollar-sign' />
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) =>
                          handleUpdateOrderTypeMaximumLimit(
                            'pickup',
                            e.target.value
                          )
                        }
                        validate={isPriceValidation}
                        style={{
                          // Hides the number input arrows
                          appearance: 'textfield',
                          MozAppearance: 'textfield',
                          WebkitAppearance: 'none',
                        }}
                      />
                    </OrderTypeWrapper>
                  )}
                  {orderTypeOverrides.includes('drop_off') && (
                    <OrderTypeWrapper>
                      <Icon
                        className='fal fa-trash-alt'
                        onClick={() => handleRemoveOverride('drop_off')}
                      />
                      <Typography
                        variant='h6'
                        style={{ fontSize: 14, cursor: 'pointer' }}
                        onClick={() => handleRemoveOverride('drop_off')}
                      >
                        Remove Drop Off Override
                      </Typography>
                      <TextField
                        label='Drop Off Maximum Order Amount'
                        value={
                          localOrderTypeTransactionLimit?.find(
                            (item) => item.order_type === 'drop_off'
                          )?.limit || null
                        }
                        placeholder='Amount'
                        variant='outlined'
                        size='small'
                        type='number'
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>
                              <Icon className='fal fa-dollar-sign' />
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) =>
                          handleUpdateOrderTypeMaximumLimit(
                            'drop_off',
                            e.target.value
                          )
                        }
                        validate={isPriceValidation}
                        style={{
                          appearance: 'textfield',
                          MozAppearance: 'textfield',
                          WebkitAppearance: 'none',
                        }}
                      />
                    </OrderTypeWrapper>
                  )}
                  {orderTypeOverrides.includes('delivery') && (
                    <OrderTypeWrapper>
                      <Icon
                        className='fal fa-trash-alt'
                        onClick={() => handleRemoveOverride('delivery')}
                      />
                      <Typography
                        variant='h6'
                        style={{ fontSize: 14, cursor: 'pointer' }}
                        onClick={() => handleRemoveOverride('delivery')}
                      >
                        Remove Delivery Override
                      </Typography>
                      <TextField
                        label='Delivery Maximum Order Amount'
                        value={
                          localOrderTypeTransactionLimit?.find(
                            (item) => item.order_type === 'delivery'
                          )?.limit || null
                        }
                        placeholder='Amount'
                        variant='outlined'
                        size='small'
                        type='number'
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position='start'>
                              <Icon className='fal fa-dollar-sign' />
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) =>
                          handleUpdateOrderTypeMaximumLimit(
                            'delivery',
                            e.target.value
                          )
                        }
                        validate={isPriceValidation}
                        style={{
                          appearance: 'textfield',
                          MozAppearance: 'textfield',
                          WebkitAppearance: 'none',
                        }}
                      />
                    </OrderTypeWrapper>
                  )}
                </AddOverrideWrapper>
              )}

              {localStorage.getItem('role') !== 'ROLE_LOYALTY_ADMIN' && (
                <Field
                  disabled={deactivateSection}
                  name='businessInformation.is_order_ahead_enabled'
                  component={RenderToggleSwitch}
                  label={
                    values.businessInformation.is_order_ahead_enabled
                      ? 'Order Ahead Enabled'
                      : 'Order Ahead Disabled'
                  }
                  onChange={(e) =>
                    setFieldValue(
                      'businessInformation.is_order_ahead_enabled',
                      e.target.checked
                    )
                  }
                />
              )}

              {is_delivery_enabled ? (
                <GridWrapper>
                  <Field
                    disabled={deactivateSection}
                    name='businessInformation.is_delivery_enabled'
                    component={RenderToggleSwitch}
                    label={
                      values.businessInformation.is_delivery_enabled
                        ? 'Delivery Enabled'
                        : 'Delivery Disabled'
                    }
                    onChange={(e) => {
                      setFieldValue(
                        'businessInformation.is_delivery_enabled',
                        e.target.checked
                      );
                      if (
                        !e.target.checked &&
                        localOrderTypeTransactionLimit
                          .map((item) => item.order_type)
                          .includes('delivery')
                      ) {
                        handleRemoveOverride('delivery');
                      }
                    }}
                  />
                  <div>
                    {values.businessInformation.is_delivery_enabled
                      ? null
                      : 'Only Pick-up will be available for this Location'}
                  </div>
                </GridWrapper>
              ) : (
                <div />
              )}
              <Field
                disabled={deactivateSection}
                name='businessInformation.is_active'
                component={RenderToggleSwitch}
                label={
                  values.businessInformation.is_active
                    ? 'Business Location Active'
                    : 'Business Location Inactive'
                }
                onChange={(e) =>
                  setFieldValue(
                    'businessInformation.is_active',
                    e.target.checked
                  )
                }
              />
              {/* <Field
                    name="businessInformation.is_visible"
                    component={RenderToggleSwitch}
                    label= {values.businessInformation.is_visible ? 
                                  "Business Location Visible" : "Business Location Invisible"}
                    onChange={e => setFieldValue('businessInformation.is_visible', e.target.checked)}
                /> */}
              <ButtonRow
                justifyContent='space-between'
                style={{
                  margin: '24px 40px 24px 40px',
                  width: 'inherit',
                }}
              >
                <Button
                  secondary
                  onClick={() => {
                    dirty ? setConfirmCancelModalIsVisible(true) : '';
                  }}
                >
                  Cancel
                </Button>
                {console.log('isValid', isValid, errors, dirty)}
                <Button
                  disabled={
                    // !dirty ||
                    // !isValid ||
                    deactivateSection || isBusinessAdminRole
                  }
                  onClick={() => {
                    if (!externalIdIsVisible) {
                      delete values.businessInformation.external_id;
                    }
                    handleSubmit(values, localOrderTypeTransactionLimit);
                  }}
                >
                  Save
                </Button>
              </ButtonRow>
              {confirmCancelModalIsVisible && (
                <ConfirmCancelModal
                  onCancel={() => setConfirmCancelModalIsVisible(false)}
                  onConfirm={() => {
                    handleReset();
                    setConfirmCancelModalIsVisible(false);
                  }}
                />
              )}
            </FormWrapper>
          )}
        </Formik>
      </Collapse>
    </Card>
  );
};

export default BusinessInformationForm;
